import { render, staticRenderFns } from "./battleNetUserUpdate.vue?vue&type=template&id=638fb7b5&scoped=true"
import script from "./battleNetUserUpdate.vue?vue&type=script&lang=js"
export * from "./battleNetUserUpdate.vue?vue&type=script&lang=js"
import style0 from "./battleNetUserUpdate.vue?vue&type=style&index=0&id=638fb7b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638fb7b5",
  null
  
)

export default component.exports